export default {
  setRelatorios (state, payload) {
    state.relatorios = payload
  }
}
